import React, { useState } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import DropdownMenu, {
	type CustomTriggerProps,
	DropdownItem,
	DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { ff } from '@atlassian/jira-feature-flagging';
import { injectIntlV2 as injectIntl, useIntl } from '@atlassian/jira-intl';
import ProjectUnarchiveModal from '@atlassian/jira-project-unarchive-modal';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller';
import messages from './messages';
import type { Props } from './types';

const UnarchiveAction = (props: Props) => {
	const {
		intl: { formatMessage: formatMessageOld },
		project,
		refetchProjects,
	} = props;
	const {
		name: projectName,
		id: projectId,
		typeKey: projectType,
		key: projectKey,
		simplified: isProjectSimplified,
		permissions,
	} = project;
	const [isProjectUnarchiveModalOpen, setProjectUnarchiveModalOpen] = useState<boolean>(false);
	const isAdmin = useIsAdmin();
	const baseUrl = '';

	const { formatMessage: formatMessageNew } = useIntl();

	const formatMessage = ff('hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3')
		? formatMessageNew
		: formatMessageOld;

	const openProjectUnarchiveModal = (): void => {
		setProjectUnarchiveModalOpen(true);
	};
	const closeProjectUnarchiveModal = (): void => {
		setProjectUnarchiveModalOpen(false);
	};
	const hasEditPermission = () => (permissions && permissions.canEdit) || isAdmin;

	if (!hasEditPermission()) {
		return null;
	}

	return (
		<DataIdWrapper data-test-id="inactive-projects-directory-base.ui.projects-table.body.cells.unarchive">
			<DropdownMenu
				placement="bottom-end"
				testId="inactive-projects-directory-base.ui.projects-table.body.cells.unarchive.dropdown"
				trigger={({ triggerRef, ...restProps }: CustomTriggerProps) => (
					<Button
						{...restProps}
						iconBefore={<MoreIcon label={formatMessage(messages.menuLabel)} />}
						ref={triggerRef}
						appearance="subtle"
					/>
				)}
			>
				<DropdownItemGroup>
					<DropdownItem onClick={openProjectUnarchiveModal}>
						{formatMessage(messages.actionUnarchiveProject)}
					</DropdownItem>
				</DropdownItemGroup>
			</DropdownMenu>
			{isProjectUnarchiveModalOpen && (
				<ProjectUnarchiveModal
					onClose={closeProjectUnarchiveModal}
					projectId={projectId}
					projectType={projectType}
					projectName={projectName}
					projectKey={projectKey}
					baseUrl={baseUrl}
					onUnarchiveSuccess={refetchProjects}
					isProjectSimplified={isProjectSimplified}
				/>
			)}
		</DataIdWrapper>
	);
};

export default injectIntl(UnarchiveAction);

// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DataIdWrapper = styled.div({});
